import { Form, Field } from 'react-final-form';
import { Grid } from '@material-ui/core';
import { FormFormattedField } from 'components/Form';
import { divisibleBy } from 'utils/validators';
import styled from 'styled-components';
import { cutTextElipsis, normalizeFormattedField } from 'utils';
import { useDispatch } from 'react-redux';
import setFieldData from 'final-form-set-field-data';
import { usePlaceAlternativeOfferMutation } from 'services/api/alternative-offers';
import { composeValidators, validateCounter } from 'utils/validators';
import { modalsHide, snackShow } from 'actions';
import ModalWrapper from 'components/ModalWrapper';

const OfferAmountContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AmountBlock = styled.div`
  border-radius: 4px;
  background: #f5f5f5;
  padding: 14px 12px;
  color: #757575;
  font-size: 14px;
  max-width: 120px;
`;

const OfferedAmount = styled.div`
  color: #000;
  font-size: 18px;
  font-weight: 500;
  width: 140px;
`;

const SendOfferText = styled.span`
  font-size: 16px;
  font-weight: 400;
`;

const divisibleBy100Validator = divisibleBy(100);

const SendAlternativeOfferModal = ({ form: modalName, vehicle }: any) => {
  const initialValues = {
    reserve_price: vehicle.reserve_price || '',
    alternative_offer: vehicle.active_alternative_offer?.amount || ''
  };

  const dispatch = useDispatch();

  const vehicleTitle = cutTextElipsis(`${vehicle.year} ${vehicle.make} ${vehicle.model}`, 20);

  const [makeAlternativeOffer] = usePlaceAlternativeOfferMutation();

  const onSubmit = async (values: any) => {
    const response = await makeAlternativeOffer({
      vehicle_id: vehicle.id,
      amount: values.alternative_offer
    });

    if ('error' in response) {
      dispatch(snackShow({ type: 'error', message: 'Failed to counter' }));
    } else {
      dispatch(snackShow({ message: 'Successful counter' }));
    }

    dispatch(modalsHide(modalName));
  };

  return (
    <Form mutators={{ setFieldData }} onSubmit={onSubmit} initialValues={initialValues}>
      {({ handleSubmit, submitting }) => (
        <ModalWrapper
          // @ts-ignore
          title={`Send Counter to ${vehicleTitle}`}
          submitting={submitting}
          handleSubmit={handleSubmit}
          modalId={modalName}
          // cancelAdditionalAction={reset}
          className="send-offer-modal"
          actionsClassName="send-offer-modal-actions"
        >
          <form name={modalName} onSubmit={handleSubmit} style={{ maxWidth: '100%' }}>
            <Grid container spacing={8}>
              <Grid item xs={12}>
                <SendOfferText>Do you want to send a counter offer?</SendOfferText>
              </Grid>
              <Grid item xs={12}>
                <OfferAmountContainer>
                  <span>Offered Amount</span>
                  <AmountBlock>
                    <OfferedAmount>
                      <Field
                        name="alternative_offer"
                        placeholder={'$0'}
                        component={FormFormattedField}
                        thousandSeparator
                        allowNegative={false}
                        fixedDecimalScale
                        prefix="$"
                        disableUnderline
                        validate={composeValidators(validateCounter, divisibleBy100Validator)}
                        parse={normalizeFormattedField}
                        fullWidth
                        hideErrors
                      />
                    </OfferedAmount>
                  </AmountBlock>
                </OfferAmountContainer>
              </Grid>
            </Grid>
          </form>
        </ModalWrapper>
      )}
    </Form>
  );
};

export default SendAlternativeOfferModal;
